import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Fragment } from "react";

import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { Box, Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { v4 as uuid } from "uuid";

import OmniAssessmentValueTextFab from "../ui/omniAssessmentValueTextFab";
import OmniTextField from "../ui/omniTextField";

const getAnswerTextAsHTML = text => {
  return { __html: `${text}` };
};

const QuestionYearDisplay = props => {
  const { question, onAnswerSelected, startNextTimer } = props;

  const theme = useTheme();

  const defaultDelay = 500;

  const [validAnswerSelected, setValidAnswerSelected] = useState(false);

  const [unsure, setUnsure] = useState(false);

  let yearInput = useRef(null);

  const [yearYYYY, setYearYYYY] = useState("");
  const [yearValid, setYearValid] = useState(false);

  useEffect(() => {
    if (question.answerValue == null) {
      setYearYYYY("");
    } else if (question.answerValue[0] === "unsure") {
      setUnsure(true);
    } else {
      setYearYYYY(question.answerValue[0]);
    }
  }, [question]);

  useEffect(() => {
    if (!unsure && yearYYYY.length === 4) {
      //valid date
      onAnswerSelected([yearYYYY]);
    }
  }, [yearYYYY, unsure, onAnswerSelected]);

  useEffect(() => {
    let currentYear = new Date().getFullYear();

    let theYear = parseInt(yearYYYY);
    let newYearValid = theYear > 1000 && theYear <= currentYear;
    setYearValid(newYearValid);

    if (newYearValid) {
      //valid date
      onAnswerSelected([theYear]);
      setUnsure(false);
      setValidAnswerSelected(true);
    } else {
      onAnswerSelected(null);
      setValidAnswerSelected(false);
    }
  }, [yearYYYY, setYearValid, setUnsure, onAnswerSelected]);

  return (
    <Fragment>
      <Grid
        container
        spacing={2}
        sx={{ marginLeft: theme.spacing(3) * -1, paddingRight: theme.spacing(3) }}
      >
        <Grid item xs={12}>
          <Box
            sx={{ justifyContent: "center", display: "flex", width: "100%", flexDirection: "row" }}
          >
            <OmniTextField
              sx={{ width: "80px" }}
              label="Year"
              type="number"
              showNumberControls={false}
              name={uuid()} //prevents AutoComplete Suggestions
              variant="outlined"
              id={"region"}
              value={yearYYYY}
              error={!yearValid}
              inputRef={yearInput}
              onFocus={event => event.target.select()}
              onChange={event => {
                let onlyNums = event.target.value.replace(/[^0-9]/g, "");
                onlyNums = onlyNums.slice(0, 4);
                setYearYYYY(onlyNums);
                setUnsure(false);
              }}
              placeholder={"YYYY"}
              onKeyPress={e => {
                if (e.key === "Enter" && validAnswerSelected) {
                  startNextTimer(defaultDelay);
                }
              }}
              autoFocus
            />
          </Box>
        </Grid>
        <Grid item xs={12} sx={{ marginTop: theme.spacing(2), marginLeft: "0", padding: "0" }}>
          <Grid
            id={`questionGrid1`}
            container
            item
            xs={12}
            justifyContent="center"
            spacing={2}
            sx={{ marginLeft: "0", padding: "0" }}
          >
            <OmniAssessmentValueTextFab
              key={`answerOption${uuid()}`}
              color="primary"
              size="large"
              variant={"outlined"}
              onClick={e => {
                setUnsure(true);
                onAnswerSelected(["unsure"]);
                startNextTimer(defaultDelay);
              }}
              sx={{ width: "100%", "&:hover": { color: theme.palette.primary.contrastText } }}
            >
              <Grid
                container
                justifyContent="center"
                direction="row"
                sx={{ width: "100%", alignItems: "center" }}
              >
                <Grid item justifySelf="center" xs>
                  <Typography
                    variant="button"
                    dangerouslySetInnerHTML={getAnswerTextAsHTML("I don't know")}
                  />
                </Grid>
                {unsure && (
                  <CheckCircleRoundedIcon
                    sx={{
                      position: "absolute",
                      top: 8,
                      right: 16,
                      maxWidth: "32px",
                      maxHeight: "32px",
                      alignSelf: "baseline",
                    }}
                  />
                )}
              </Grid>
            </OmniAssessmentValueTextFab>
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default QuestionYearDisplay;
